<template>
<b-modal ref="loginModal" class="container" id="modal-1" title="Connexion" hide-footer>
  <div class="d-flex justify-content-center h-100">
    <b-form>
      <div class="input-group form-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="fas fa-user"></i></span>
        </div>
        <b-form-input @keyup.enter="onSubmit()" type="text" class="form-control" v-model="currentUser.username" placeholder="utilisateur"></b-form-input>
      </div>
      <div class="input-group form-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="fas fa-key"></i></span>
        </div>
        <b-form-input @keyup.enter="onSubmit()" type="password" class="form-control" v-model="currentUser.password" placeholder="mot de passe"></b-form-input>
      </div>
      <div class="form-group">
        <b-button @click="onSubmit()" class="btn float-right login_btn">Login</b-button>
      </div>
    </b-form>
  </div>
  <div id="forgottenPassword" class="d-flex justify-content-center">
    <a class="mailTo" href="mailto:maeva.seffar@univ-grenoble-alpes.fr,Philippe.Genoud@imag.fr">Mot de passe oublié ?</a>
  </div>
  </div>
  </div>
</b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LoginPage',
  data() {
    return {
      currentUser: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    onSubmit: function() {
      this.$store.dispatch('login', this.currentUser)
      this.$refs['loginModal'].hide()
    }
  }
}
</script>

<style>
.mailTo {
  color: white;
}

#modal-1___BV_modal_content_  {
  margin-top: 50%;
  color: white;
  background-color: rgba(128, 0, 0, 0.7) !important;
}

.container {
  height: 100%;
  align-content: center;
}

.input-group-prepend span {
  width: 50px;
  background-color: #E0E4CC;
  color: black;
  border: 0 !important;
}

b-form-input:focus {
  outline: 0 0 0 0 !important;
  box-shadow: 0 0 0 0 !important;

}

.login_btn {
  color: black;
  background-color: #E0E4CC;
  margin: 20px;
  width: 100px;
}

.login_btn:hover {
  color: black;
  background-color: white;
}

#forgottenPassword {
  padding: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/LoginPage.vue